import { combineEpics } from 'redux-observable';
import { HubUsersActionTypes, FetchHubUsers } from '../actions/HubUsersActions';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import HubUsersAPI from '../api/HubUsersApi';
import { getFetchHubUsersRequestStatus } from '../selectors/RequestStatusSelector';
import { RequestEpicDescriptor, requestEntity } from 'settings-ui-lib/utils/epics';
const fetchHubUsers = requestEntity(new RequestEpicDescriptor({
  apiFunction: HubUsersAPI.getHubUsers,
  initiatingActionType: HubUsersActionTypes.LOAD_HUB_USERS,
  requestStatusSelector: getFetchHubUsersRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.FAILED],
  requestActions: FetchHubUsers
}));
export default combineEpics(fetchHubUsers);